<ng-container *transloco="let t">
  <span class="plan-badge">
    <span class="plan-badge__chip" [class.plan-badge__chip--paid]="!isFree()">
      <i class="pi pi-crown"></i>
      <span class="plan-badge__text">{{ t('plans.planBadge') }} {{ label() }}</span>
    </span>

    @if (showUpgrade() && isFree()) {
      <button type="button" class="plan-badge__cta" (click)="upgrade.emit()">
        {{ t('plans.upgradeCta') }}
      </button>
    }
  </span>
</ng-container>
